import React, { useRef, useEffect } from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import styled from "styled-components"
import parse from "html-react-parser"
import FakeButtonModal from "./FakeButtonModal"
import ButtonExternal from "./ButtonExternal"
import Button from "./Button"
import RellaxWrapper from "react-rellax-wrapper"
import { BsArrowDown } from "react-icons/bs"
import ButtonEmail from "./ButtonEmail"

const Hero = styled.section`
  width: 100%;
  position: relative;
  background: var(--brandColor) !important;
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;

  @media only screen and (min-width: 1024px) {
    min-height: 750px;
    height: calc(100vh - var(--headerHeight));
    height: calc((var(--vh, 1vh) * 100) - var(--headerHeight));
    display: block;

    /* min-height:750px;
    height:calc(100vh - var(--headerHeight)); */
  }

  @keyframes slide-bottom {
    0% {
      -webkit-transform: translateY(0);
      transform: translateY(0);
    }
    100% {
      -webkit-transform: translateY(10px);
      transform: translateY(10px);
    }
  }
  .scroller {
    position: absolute;
    right: 1rem;
    bottom: 2rem;
    color: var(--black);
    z-index: 10;
    writing-mode: vertical-rl;
    text-orientation: mixed;
    display: flex;
    align-items: center;
    justify-content: center;
    animation: slide-bottom 0.75s cubic-bezier(0.895, 0.03, 0.685, 0.22)
      infinite alternate both;

    span {
      margin-bottom: 1rem;
      font-family: var(--font-heading);
      text-transform: uppercase;
      font-size: 1.4rem;
    }
    svg {
      font-size: 2rem;
    }
  }

  .rellax {
    position: relative !important;

    @media only screen and (min-width: 1024px) {
      position: absolute !important;
    }
  }

  .left {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    flex-direction: column;
    max-height: 40vh;

    @media only screen and (min-width: 1024px) {
      max-height: 100vh;
      max-height: calc(var(--vh, 1vh) * 100);
      padding: 0 4rem;
      width: 60%;
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
    }

    .image-wrap {
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 0;
      position: relative;
      background: var(--black);

      @media only screen and (min-width: 1024px) {
        position: absolute;
        height: 100%;
      }

      .gatsby-image-wrapper {
        position: absolute;
        width: 100%;
        height: 100%;
        opacity: 0.6;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
  }

  .right {
    width: 100%;
    position: relative;
    padding: 2rem;
    background: ${props => `var(--${props.backgroundColor})`};
    /* margin-top:50%; */

    @media only screen and (min-width: 750px) {
      /* margin-top:40%; */
    }

    @media only screen and (min-width: 1024px) {
      position: absolute;
      height: 100%;
      top: 0;
      right: 0;
      padding: 0 4rem;
      width: 40%;
      margin-top: 0%;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      flex-direction: column;
    }

    h1 {
      color: var(--black);
      z-index: 1;
      position: relative;
    }

    .text {
      font-family: var(--font-reg);
      color: var(--black);
      z-index: 1;
      position: relative;
      max-width: 480px;
      margin-bottom: 4rem;
      width: 100%;

      p {
        line-height: 1.5rem;
        margin-bottom: 1rem;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    .button {
      flex-basis: 0 0 0 0;
    }
  }
`

export default function HeroDefault(data) {
  const wrapperStyles = {
    height: "100%",
    width: "100%",
    position: "absolute",
    top: "0",
    left: "0",
  }

  const hero = useRef()

  return (
    <Hero
      ref={hero}
      backgroundColor={data.backgroundColor}
      className="heroDefault"
    >
      <div className="scroller">
        <span>Scroll</span> <BsArrowDown />
      </div>
      <div className="left">
        <div className="image-wrap">
          <RellaxWrapper className="rellax" speed={-1.25} style={wrapperStyles}>
            <GatsbyImage
              image={
                data.backgroundImage.localFile.childImageSharp.gatsbyImageData
              }
            />
          </RellaxWrapper>
        </div>
      </div>
      <RellaxWrapper className="rellax" speed={2} style={wrapperStyles}>
        <div className="right">
          <h1 className="heading--xl">{data.title}</h1>
          <div className="text">{parse(data.text)}</div>
          {data.buttonText !== null ? (
            data.buttonType === "external" ? (
              <ButtonExternal
                color="black"
                bg={"black"}
                text={data.buttonText}
                link={data.buttonLink}
              />
            ) : data.buttonType === "internal" ? (
              <Button
                color="black"
                text={data.buttonText}
                bg={data.backgroundColor}
                link={data.buttonLink}
              />
            ) : data.buttonType === "launchContact" ? (
              <FakeButtonModal
                color="black"
                text="Contact us"
                withHover={true}
              />
            ) : data.buttonType === "emailContact" ? (
              <ButtonEmail
                color="black"
                bg={"black"}
                text={"Contact us"}
                link={"hello@independentlife.co.uk"}
              />
            ) : (
              ""
            )
          ) : (
            ""
          )}
        </div>
      </RellaxWrapper>
    </Hero>
  )
}
